<template>
  <div class="card">
    <div class="card-content">
      <p class="subtitle has-text-centered">
        <b-button
          tag="a"
          @click="authenticate"
          type="is-link is-primary"
          icon-right="key-link"
        >
          {{ $t('components.signingSteps.authentication.eidas.label') }}
        </b-button>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <b-button
          v-if="renderSecondButton"
          tag="a"
          @click="authenticate2"
          type="is-link is-primary"
          icon-right="key-link"
        >
          {{ $t('components.signingSteps.authentication.second.taxislabel') }}
        </b-button>
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import getEnv from '@/store/env'

export default {
  name: 'Authentication',
  computed: {
    renderSecondButton () {
      return (getEnv('VUE_APP_ENABLE_2ND_LOGIN') === 'true')
    }
  },
  methods: {
    ...mapActions([
      'authenticate',
      'authenticate2'
    ])
  }
}
</script>
